export default [
  {
    _name: "CSidebarNav",
    
    _children: [
      {
        _name: "CSidebarNavItem",
        name: "Relatórios",
        to: "/dashboard",
        icon: "cil-people",
        // items: [
        //   {
        //     name: "Listagem",
        //     to: "/pacientes",
        //   },
        // ],
        // localStorage,
      },
      {
        _name: "CSidebarNavItem",
        name: "Pacientes",
        to: "/pacientes",
        icon: "cil-people",
       
        localStorage,
      },
      {
        _name: "CSidebarNavItem",
        name: "Profissionais",
        to: "/profissionais",
        icon: "cil-user",
        
      },
      {
        _name: "CSidebarNavItem",
        name: "Calendario",
        to: "/calendario/listar",
        icon: "cil-calendar",
        
      },
      {
        _name: "CSidebarNavItem",
        name: "Consultas",
        icon: "cil-calendar-check",
        to: "/consultas",
        
      },
      {
        _name: "CSidebarNavItem",
        name: "Cadastros",
        to: "/cadastro",
        icon: "cil-address-book",
        
      },
      // {
      //   _name: "CSidebarNavDropdown",
      //   name: "Convenios",
      //   route: "/convenios",
      //   icon: "cil-loop",
      //   
      // },
      {
        _name: "CSidebarNavItem",
        name: "Salas",
        to: "/salas",
        icon: "cil-door",
        
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Integração",
        route: "/integration",
        icon: "cil-door",
        items: [
          {
            name: "Pacientes",
            to: "/integration/patients",
          },
          {
            name: "Consultas",
            to: "/integration/consults",
          },
        ],
      },
      
    ],
  },
];
